import styled from 'styled-components';

export const Card = styled.a`
  display: flex;
  position: relative;
  width: 100%;
  padding: 9px;
  border-radius: ${({ theme }) => theme.borderRadius};
  box-shadow: ${({ theme }) => theme.boxShadow};
  margin: 0 auto;
  background-color: #fff;
  color: ${({ theme }) => theme.colors.font};
  backface-visibility: hidden;
  transition: transform 0.15s ease;

  &:before {
    position: absolute;
    z-index: -1;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    opacity: 0;
    box-shadow: ${({ theme }) => theme.boxHoverShadow};
    content: '';
    transition: opacity 0.15s ease;
  }

  /* stylelint-disable */
  @media (hover: hover), screen and (-ms-high-contrast: active), screen and (-ms-high-contrast: none) {
    &:hover {
      transform: translateY(-2px);
    }

    &:hover:before {
      opacity: 1;
    }
  }
  /* stylelint-enable */

  &:active {
    transform: translateY(0);

    &:before {
      opacity: 0;
    }
  }
`;
